import React, { useState, useEffect } from 'react'
import PageLayout from './common/layout/PageLayout'
import MarkdownRenderer from './common/MarkdownRenderer'
import './LegalDocument.css'

function PrivacyPolicy() {
  const [content, setContent] = useState('')

  useEffect(() => {
    fetch('/legal/privacy_policy.md')
      .then((response) => response.text())
      .then((text) => setContent(text))
      .catch((error) => console.error('Error loading Privacy Policy:', error))
  }, [])

  return (
    <PageLayout
      title="Privacy Policy"
      noCard={true}
      heroContent={<></>}
      showHeader={false}
    >
      <div className="legal-page-wrapper">
        <div className="legal-document">
          {content ? (
            <MarkdownRenderer content={content} />
          ) : (
            <p>Loading Privacy Policy...</p>
          )}
        </div>
      </div>
    </PageLayout>
  )
}

export default PrivacyPolicy
